import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3" data-testid={testId}>
      <div className="min-w-0">
        <h1 className="break-words text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 break-words text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ title, action, children, className, testId, dense }) {
  return (
    <section className={cn("fv-card", dense ? "p-3" : "p-5", className)} data-testid={testId}>
      {(title || action) && (
        <div className="mb-3 flex items-center justify-between gap-2">
          {title && <h2 className="text-base font-semibold">{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function EmptyState({ title, description, action, testId }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed px-6 py-12 text-center" data-testid={testId}>
      <Inbox className="mb-3 h-8 w-8 text-muted-foreground" />
      <p className="text-sm font-semibold">{title}</p>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Stat({ label, value, sub, tone, testId }) {
  const tones = { danger: "text-destructive", warn: "text-[#B78103] dark:text-[#FFD54F]", ok: "text-[#1B5E20] dark:text-[#81C784]" };
  return (
    <div className="fv-card p-4" data-testid={testId}>
      <p className="fv-caption">{label}</p>
      <p className={cn("mt-1 text-2xl font-bold tracking-tight", tones[tone])}>{value}</p>
      {sub && <p className="mt-0.5 text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function Spinner() {
  return <div className="flex justify-center py-12" data-testid="loading-spinner"><div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" /></div>;
}
